import { INgsiIdDesignPattern } from '../helpers/ngsild.constants'
import { IMapWidgetFormGroupSettings } from '../../../map-widget-settings/map-widget-settings.interface'
import { INgsiFusionMaritimeTarget } from '../interfaces/ngsi-fusion-maritime-target.interface'
import { ILeafletInstance } from '../../leaflet/leaflet.interface'
import { PopupService } from '../../leaflet/popup/popup.service'
import { TooltipService } from '../../leaflet/tooltips/tooltip.service'
import L from '../../leaflet/leaflet-plugins-loader';
import * as DivIcons from '../../leaflet/markers/div-icons/div-icons-constant'
import * as AisTrackSymbol from '../../leaflet/markers/leaflet-tracksymbol2/ais-track-symbol'
import { TrackerDetails } from '../../leaflet/markers/leaflet-tracksymbol2/ais-track-symbol'
import { MarkerService } from '../../leaflet/markers/marker.service'
import { INgsiEntity } from '../interfaces/ngsi-entity.interface'
import { IMapWidgetPermissions } from '../../../../shared/interfaces/map-widget-permission.interface'
import { INotification } from 'ngsild-connector'

export const entityType: string = `FusionMaritimeTarget`
export const fusionMaritimeTargetOwner: string = 'CAPTN'

export const ngsiFusionTargetsIdPattern: Omit<INgsiIdDesignPattern, 'idPattern'> = {
    prefix: `urn:ngsi-ld:`,
    type: entityType,
    owner: fusionMaritimeTargetOwner
}

const allowDisplayOfEntity = (
    settings: IMapWidgetFormGroupSettings,
    entity: INgsiEntity
): boolean => {
    return entity.type === entityType && settings.enableFusionMaritimeTarget;
}

export const grantEntityPassage = (
    notification: INotification,
    appPluginWidgetSettings: IMapWidgetFormGroupSettings,
    widgetPermissions: IMapWidgetPermissions
): boolean => {
    const settings = appPluginWidgetSettings
    if (settings?.entities) {
        return widgetPermissions.fusionMaritimeTargetDataEnabled &&
            allowDisplayOfEntity(settings, notification.data[0]);
    } else {
        return false;
    }
}

export function createMarker(
    entity: INgsiFusionMaritimeTarget,
    settings: IMapWidgetFormGroupSettings,
    instance: ILeafletInstance,
    popupService: PopupService,
    tooltipService: TooltipService,
    markerService: MarkerService
): L.Marker<any> | undefined {
    // 1. Neuer Marker (Punkt-Icon) an den Koordinaten
    const marker = L.marker(
        [entity.location.coordinates[1], entity.location.coordinates[0]],
        { icon: DivIcons.circleDotIcon('#183DAA') }
    )

    const positionReport = AisTrackSymbol.setAISPositionReport(<any>entity)
    const options = AisTrackSymbol.setAISReportOptions(<any>entity)

    const trackerDetails: TrackerDetails = {
        marker,
        positionReport,
        options
    }

    popupService.bindPopupOnce(marker, entity, settings, instance, popupService, trackerDetails)

    return marker
}

export function updateMarker(
    entity: INgsiFusionMaritimeTarget,
    marker: L.Marker<any>,
    settings: IMapWidgetFormGroupSettings,
    instance: ILeafletInstance,
    popupService: PopupService,
    tooltipService: TooltipService,
    markerService: MarkerService
): L.Marker<any> | undefined {
    if (!marker) {
        return undefined
    }

    marker.setLatLng([entity.location.coordinates[1], entity.location.coordinates[0]])

    const positionReport = AisTrackSymbol.setAISPositionReport(<any>entity)
    const options = AisTrackSymbol.setAISReportOptions(<any>entity)

    const trackerDetails: TrackerDetails = {
        marker,
        positionReport,
        options
    }

    instance.additionalEntities.set(entity.id, entity)
    instance.markers.set(entity.id, marker)

    popupService.bindPopupOnce(marker, entity, settings, instance, popupService, trackerDetails)

    return marker
}
